// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 12 13" {...rest} unit={unit}>
		<g transform="translate(-25.000000, -24.000000)">
			<path d="M35.7074148,32.4843019 C35.5858383,35.1155645
			33.6232465,37 30.4188377,37 C27.006012,37 25,34.6379426 25,30.7648631
			L25,30.252505 C25,26.3794255 27.1362725,24 30.4014696,24 C33.7708751,24
			35.498998,26.0146961 35.7247829,28.6285905 L32.4595858,28.6285905
			C32.4248497,27.3346693 31.9385438,26.6746827 30.4014696,26.6746827
			C28.9512358,26.6746827 28.3259853,27.6038744 28.3259853,30.2351369
			L28.3259853,30.7648631 C28.3259853,33.3874415 28.8122912,34.3253173
			30.4188377,34.3253173 C31.756179,34.3253173 32.3987976,33.752171
			32.4422178,32.4843019 L35.7074148,32.4843019 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/C.js